import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import { actions, selectors } from './';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import MainForm from '../components/forms/general/main';

const Main = renderViewsState(props => (
	<Animate>
		<div className='container__content goods-editor'>
			<div className='container__content-title'>
				<div className='container__content-title-position'>
					<Link
						to='/missions'
						className='link'
					>{props.intl('Return to list of missions')}</Link>
				</div>
				<div className='container__content-title-position'>
					<h2 className='title'>{props.intl('Mission editor')}</h2>
				</div>
			</div>
			<div className='container__content-body'>
				<div className='form-container everad_good-editor'>
					<div className='form-container__head'>
						<h2 className='title icon-edit'>{props.intl('Create/edit mission')}</h2>
					</div>
					<div className='good-container'>
						<MainForm
							{...props}
							initialValues={props.mainFormData.initialValues}
							enableReinitialize={true}
						/>
					</div>
				</div>
			</div>
		</div>
	</Animate>
), 'edit');

Main.propTypes = {
	intl: PropTypes.func,
	mainFormData: PropTypes.object
};

export default connect(
	state => ({
		data: selectors.getData(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		mainFormData: selectors.getMainFormData(state),
		progressBar: selectors.getProgressBar(state),
		mainTabLangs: selectors.getMainTabLangs(state),
		offerCategoriesOptions: selectors.getOfferCategoriesOptions(state),
		startPeriodOptions: selectors.getStartPeriodOptions(state),
		currentLanguage: selectors.getCurrentLanguage(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/editor/main.js